
@if (href == null) {
  <button
    class="flex items-center justify-center"

    [class.primary-solid]="color === 'primary' && variant === 'solid' && !customColor"
    [class.secondary-solid]="color === 'secondary' && variant === 'solid' && !customColor"
    [class.gray-solid]="color === 'gray' && variant === 'solid' && !customColor"
    [class.gray2-solid]="color === 'gray2' && variant === 'solid' && !customColor"
    [class.black-solid]="color === 'black' && variant === 'solid' && !customColor"
    [class.white-solid]="color === 'white' && variant === 'solid' && !customColor"
    [class.red-solid]="color === 'error' && variant === 'solid' && !customColor"
    [class.red-outline]="color === 'error' && variant === 'outline' && !customColor"
    [class.dark-solid]="color === 'dark' && variant === 'solid' && !customColor"
    [class.dark-outline]="color === 'dark' && variant === 'outline' && !customColor"
    [class.green-solid]="color === 'success' && variant === 'solid' && !customColor"
    [class.blue-solid]="color === 'info' && variant === 'solid' && !customColor"

    [class.xl]="size === 'xl'"
    [class.lg]="size === 'lg'"
    [class.md]="size === 'md'"
    [class.sm]="size === 'sm'"
    [class.xs]="size === 'xs'"
    [class.input]="size === 'input'"

    [class.rounded-r-lg]="roundedRight"
    [class.rounded-l-lg]="roundedLeft"
    [class.rounded-full]="roundedFull"

    [class.w-full]="block"

    [class.opacity-75]="loading || disabled"

    [class.pointer-events-none]="disabled"

    [style]="customColor ? ('background-color: '+customColor + '; color: ' + customText + ';') : undefined"

    [type]="type"
    [disabled]="loading || disabled"
    (click)="onClick.next($event)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"> </ng-container>
  </button>
}

@if (href != null) {
  <a
    class="flex items-center justify-center"

    [class.primary-solid]="color === 'primary' && variant === 'solid'"
    [class.secondary-solid]="color === 'secondary' && variant === 'solid'"
    [class.gray-solid]="color === 'gray' && variant === 'solid'"
    [class.gray2-solid]="color === 'gray2' && variant === 'solid'"
    [class.black-solid]="color === 'black' && variant === 'solid'"
    [class.white-solid]="color === 'white' && variant === 'solid'"
    [class.red-solid]="color === 'error' && variant === 'solid'"
    [class.dark-solid]="color === 'dark' && variant === 'solid'"
    [class.green-solid]="color === 'success' && variant === 'solid'"
    [class.blue-solid]="color === 'info' && variant === 'solid'"

    [class.lg]="size === 'lg'"
    [class.md]="size === 'md'"
    [class.input]="size === 'input'"

    [class.rounded-r-lg]="roundedRight"
    [class.rounded-l-lg]="roundedLeft"

    [class.w-full]="block"

    [class.opacity-65]="loading || disabled"

    [class.pointer-events-none]="disabled"

    [href]="href"
    [target]="target"
    (click)="onClick.next($event)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"> </ng-container>
  </a>
}

<ng-template #buttonContent>
  @if (!loading) {
    <ng-content></ng-content>
  } @else {
    <img
      src="assets/icons/loader-puff.svg"
      class="w-5 h-5"
      [class.invert]="color === 'white' || color === 'gray' || variant === 'outline'"
    />
  }
</ng-template>